module.exports = __webpack_public_path__ + "static/media/menu-ico.dcb7c198.svg";